import { useContext } from 'react';
import { useGetUser, useOnUserUpdate } from '@/api/graphql';
import { useCheckSession } from '@/common/hooks/useCheckSession';
import { AuthenticationContext } from '@/common/providers/AuthenticationProvider/AuthenticationContext';

export const useUserSubscription = () => {
  const checkSession = useCheckSession();
  const { data, refetch, ...rest } = useGetUser();
  const context = useContext(AuthenticationContext);
  const { organizationId, userId } = context.claims!;

  useOnUserUpdate({
    variables: {
      organizationId,
      userId,
    },
    skip: !userId || !organizationId,
    onData: async (subscriptionData) => {
      const currentAuth0Role = data?.getUser?.userOrgData?.auth0?.role;
      const newAuth0Role =
        subscriptionData.data?.data?.onUserUpdate?.userOrgData?.auth0?.role;

      if (newAuth0Role && currentAuth0Role !== newAuth0Role) {
        // Check the session and rerun all requests with the new token
        await checkSession();
      }
    },
  });

  return {
    user: data?.getUser,
    data,
    refetch,
    ...rest,
  };
};
